import { useState } from "react";
import { observer } from "mobx-react";
import { CloseSquare } from "iconsax-react";
import { Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
import QRIcon from '../../icons/qr.png';
import QRCode from 'qrcode.react';

const QRModal = observer(({ cardId }) => {
    const [show, setShow] = useState(false);

    return (
        <>
            <Button onClick={() => setShow(true)} color='greyPrimary'>
                <img src={QRIcon} alt='Share' />
                QR
            </Button>

            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            >
                <DialogTitle>
                    Share Card
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <QRCode value={`${window.location.protocol}//${window.location.hostname}/card/${cardId}`} />
                </DialogContent>
            </Dialog>
        </ >
    );
});

export default QRModal;
